module.exports = __webpack_public_path__ + "img/hero-animation-left.b2cc1534.svg";